"use strict";

exports.intSub = function (x) {
  return function (y) {
    /* jshint bitwise: false */
    return x - y | 0;
  };
};

exports.numSub = function (n1) {
  return function (n2) {
    return n1 - n2;
  };
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Ring/foreign.js
// module id = 300
// module chunks = 0